import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const addAnswerToFormInstance = async (
	payload: Partial<IObservationAnswerPayload>
) => {
	const url = "/observations/responses/";

	const response = await cmsClient.post<IObservationForm>(url, payload);
	return response.data;
};

const useAddAnswerToFormInstance = () => {
	const mutation = useMutation(addAnswerToFormInstance);

	return mutation;
};

export default useAddAnswerToFormInstance;
